/* eslint-disable */
import { Component, Element, h, Prop } from '@stencil/core';

const players = {
  default: '5tEM6BSxSNd28ZZCQLweM4',
  loop: '-_VV2zpMELJzqDNgrB5TG9',
};

/**
 * This component is used to embed a video from MovingImage.
 * If you want to embed a video hosted on a different platform, this component is not suitable and has to be extended.
 */
@Component({
  tag: 'ui-cms-video',
  styleUrl: 'ui-cms-video.scss',
})
export class UiCmsVideo {
  @Element() el: HTMLUiCmsVideoElement;

  /**
   * Video ID from MovingImage
   */
  @Prop() videoId: string;

  /**
   * When set to *true*, the video loops indefinitely. The default value is *false*.
   */
  @Prop() loop = false;

  /**
   * When set to *true*, the video has no sound. The default value is *false*.
   */
  @Prop() muted = false;

  private htmlPath = window.ui.services.video.getVideoHTMLPath();

  private playerId = players[this.loop ? 'loop' : 'default'];

  render() {
    return (
      this.videoId && (
        <ui-cms-iframe
          body={{
            src: `${this.htmlPath}?video-id=${this.videoId}&player-id=${this.playerId}${this.muted ? '&muted=true' : ''}`,
            isAutoResized: true,
            isLowestElementActivated: true,
            allowFullScreen: true,
          }}
        ></ui-cms-iframe>
      )
    );
  }
}
